import { CloseCircleFilled, CloudServerOutlined, DownloadOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import CreateImportDataTemplateModal from '../TemplateModal/CreateImportDataTemplateModal'
import { mixGetV2 } from '../../../../services/mixin'
import { API_URL_v2 } from "../../../../env";

const excelIcon = <svg width="1em" height="1.042em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clipPath="url(#clip0_15514_69625)"> <path fillRule="evenodd" clipRule="evenodd" d="M6.14449 0.5H14.1766L20.9737 7.59489V21.373C20.9737 23.0985 19.581 24.5 17.8554 24.5H6.14449C4.4277 24.5 3.02625 23.0985 3.02625 21.373V3.61824C3.02621 1.90145 4.4277 0.5 6.14449 0.5Z" fill="#00733B"/> <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M14.1678 0.5V7.53358H20.9737L14.1678 0.5Z" fill="white"/> <path d="M10.489 17.9744H9.32403L8.52697 16.6343L7.72987 17.9744H6.55615L7.94011 15.6445L6.7226 13.6211H7.89629L8.52694 14.6722L9.14882 13.6211H10.3225L9.11376 15.6533L10.489 17.9744ZM10.9007 17.9744V13.6211H12.0131V17.0284H13.905V17.9744H10.9007V17.9744ZM15.7445 18.027C15.3065 18.027 14.9211 17.8868 14.5883 17.6153C14.2642 17.3525 14.0802 17.0197 14.054 16.6255L15.0087 16.3452C15.035 16.5555 15.1226 16.7394 15.2715 16.8796C15.4291 17.0197 15.6043 17.0898 15.797 17.0898C15.9547 17.0898 16.0861 17.0547 16.1912 16.9847C16.2875 16.9146 16.3401 16.8182 16.3401 16.7044C16.3401 16.608 16.2963 16.5292 16.2175 16.4591C16.1386 16.3978 16.0335 16.3452 15.9109 16.3015C15.7882 16.2577 15.6394 16.2139 15.4904 16.1788C15.3328 16.135 15.1751 16.0825 15.0262 16.0124C14.8685 15.9511 14.7284 15.8723 14.6058 15.7759C14.4744 15.6883 14.378 15.5569 14.2992 15.3905C14.2203 15.2328 14.1766 15.0401 14.1766 14.8212C14.1766 14.462 14.3254 14.1642 14.632 13.9277C14.9386 13.6825 15.3065 13.5686 15.7357 13.5686C16.1649 13.5686 16.5415 13.6737 16.8568 13.8752C17.1722 14.0854 17.3736 14.3569 17.4525 14.6898L16.4539 15.1102C16.4101 14.9263 16.3225 14.7774 16.1999 14.6635C16.0773 14.5584 15.9196 14.4971 15.7357 14.4971C15.5955 14.4971 15.4904 14.5321 15.4028 14.5847C15.324 14.6372 15.289 14.7161 15.289 14.8124C15.289 14.9 15.3415 14.9788 15.4466 15.0402C15.5517 15.0927 15.6919 15.1365 15.8495 15.1628C16.0072 15.1891 16.1824 15.2329 16.3663 15.2942C16.559 15.3643 16.7254 15.4343 16.8919 15.5307C17.0495 15.6183 17.1809 15.7672 17.286 15.9599C17.3999 16.1614 17.4524 16.3979 17.4524 16.6694C17.4524 17.0723 17.2948 17.4052 16.9794 17.6504C16.6641 17.8956 16.2525 18.027 15.7445 18.027Z" fill="white"/> </g> <defs> <clipPath id="clip0_15514_69625"> <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/> </clipPath> </defs> </svg>

const unionIcon = <svg width="1em" height="1.07em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clipPath="url(#clip0_15694_12694)"> <path d="M12.8794 11.3327H12.0388C11.9732 11.3327 11.9185 11.3874 11.9185 11.453V12.4186H2.07944V2.57798H11.9201V3.5436C11.9201 3.60923 11.9748 3.66392 12.0404 3.66392H12.881C12.9466 3.66392 13.0013 3.61079 13.0013 3.5436V1.97798C13.0013 1.71235 12.7873 1.49829 12.5216 1.49829H1.47944C1.21382 1.49829 0.999756 1.71235 0.999756 1.97798V13.0186C0.999756 13.2842 1.21382 13.4983 1.47944 13.4983H12.5201C12.7857 13.4983 12.9998 13.2842 12.9998 13.0186V11.453C12.9998 11.3858 12.9451 11.3327 12.8794 11.3327ZM13.0935 6.93579H8.18726V5.74829C8.18726 5.6436 8.06538 5.58423 7.98413 5.64985L5.76694 7.39985C5.752 7.41155 5.73992 7.42649 5.73161 7.44354C5.7233 7.4606 5.71898 7.47932 5.71898 7.49829C5.71898 7.51726 5.7233 7.53599 5.73161 7.55304C5.73992 7.5701 5.752 7.58504 5.76694 7.59673L7.98413 9.34673C8.06695 9.41235 8.18726 9.35298 8.18726 9.24829V8.06079H13.0935C13.1623 8.06079 13.2185 8.00454 13.2185 7.93579V7.06079C13.2185 6.99204 13.1623 6.93579 13.0935 6.93579Z" fill="currentColor"/> </g> <defs> <clipPath id="clip0_15694_12694"> <rect width="14" height="14" fill="white" transform="translate(0 0.5)"/> </clipPath> </defs> </svg>
interface Props {
  listFilesChange?: (e: any) => void
  fileData?: any
}

const ImportDataStep1: React.FC<Props> = (props) => {
  const { listFilesChange, fileData } = props
  const [showImportDataTemplateModal, setShowImportDataTemplateModal] = useState(false)

  let wait = false
  const [listData, setListData] = useState([] as any)
  const getListData = async () => {
    if (wait === true) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/template_excels?sort[]=id,desc&page=1&limit=5')
    wait = false
    if (res.status) {
      setListData(res.data.items)
    }
  }

  useEffect(()=>{
    getListData()
  }, [])

  const fileInput = useRef(null as any)
  const [files, setFiles] = useState([] as any)
  const fileChange = (e: any) => {
    const list = [] as any
    Object.keys(e.target.files).map((val: any) => {
      list.push({
        temp: e.target.files[val],
        name: e.target.files[val].name,
        status: 1,
        res: null,
      })
      return true
    })
    setFiles(list)
    e.target.value = null
    if (listFilesChange) {
      listFilesChange(list)
    }
  }
  const fileRemove = (name: any) => {
    const temps = files.filter((x: any) => x.name !== name)
    setFiles([...temps])
    if (listFilesChange) {
      listFilesChange(temps)
    }
  }

  const statusText = {
    s1: {
      text: 'Mới',
    },
    s2: {
      text: 'Đang xử lý'
    },
    s3: {
      text: 'Thành công'
    },
    s4: {
      text: 'Xảy ra lỗi'
    }
  } as any

  const [listSource, setListSource] = useState([] as any)
  let wait1 = false
  const getSource = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/fe/setting/column_warehouse')
    wait1 = false
    if (res.status) {
      const items = JSON.parse(res.data.value)
      const temp = [] as any
      items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSource([...temp])
    }
  }

  const [listSourceV2, setListSourceV2] = useState([] as any)
  let wait2 = false
  const getSourceV2 = async () => {
    if (wait2) {
      return
    }
    wait2 = true
    const res = await mixGetV2('/api/v1/be/sources')
    wait2 = false
    if (res.status) {
      const items = res.data.items
      const temp = [] as any
      items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSourceV2([...temp])
    }
  }
  useEffect(() => {
    getSource()
    getSourceV2()
  }, [])

  const getStatus = (name: any) => {
    let res = 1
    const findData = files.find((x: any) => x.name !== name)
    if (findData) {
      res = findData.status
    }
    return res
  }

  return (
    <>
      <div className="import-data-step-1">
        <Flex vertical className='gap-16px'>
          <div className="upload-file-block">
            <Flex
              wrap='wrap'
              align='center'
              justify='space-between'
              className='8px'
            >
              <Flex
                align='center'
                className='upload-file-block__head gap-24px'
              >
                <CloudServerOutlined className='icon' />
                <div className="fsz-16 font-medium">Tải file lên</div>
              </Flex>
              <Button
                icon={unionIcon}
                className='rs-button rs-button--sm primary-outline'
                onClick={() => fileInput.current.click()}
              >Chọn File từ máy tính</Button>
              <input className='d-none' type="file" accept=".xlsx" multiple ref={fileInput} onChange={(e) => fileChange(e)} />
            </Flex>

            <div className="upload-file-block__preview">
              {
                Object.keys(fileData).map((iskey: any, index: any) => (
                  <div className="item" key={index}>
                    <span className="icon">{ excelIcon }</span>
                    <div className="title">{iskey} [{statusText[`s${getStatus(iskey)}`].text}]</div>
                    <CloseCircleFilled onClick={() => fileRemove(iskey)} />
                  </div>
                ))
              }
              {/* <div className="item">
                <span className="icon">{ excelIcon }</span>
                <div className="title">IPCC_Sale_Customer_20240716.xls</div>
                <CloseCircleFilled />
              </div>
              <div className="item">
                <span className="icon">{ excelIcon }</span>
                <div className="title">Saleforce_Sale_Customer_20240716.xls</div>
                <CloseCircleFilled />
              </div>
              <div className="item">
                <span className="icon">{ excelIcon }</span>
                <div className="title">Saleforce_Sale_Customer_20240716.xls</div>
                <CloseCircleFilled />
              </div> */}
            </div>
          </div>

          <Flex
            align='center'
            className='gap-10px'
          >
            <span>Nếu bạn chưa có file template mẫu, vui lòng download bên dưới hoặc tạo mẫu mới</span>
            <Button
              type='dashed'
              icon={<PlusOutlined />}
              className='rs-button rs-button--sm primary-7'
              onClick={() => setShowImportDataTemplateModal(true)}
            >Tạo file mẫu mới</Button>
          </Flex>

          <Flex
            vertical
            align='flex-start'
            className='gap-4px'
          >
            <div className="fsz-16 font-medium">File mẫu</div>
            {
              listData.map((val: any, index: any) => (
                <Button
                  key={index}
                  icon={<DownloadOutlined />}
                  className='rs-button file-download'
                  // onClick={ () => {window.location.href = `${API_URL_v2}/api/v1/warehouse/download_excel/${val.id}`}}
                  onClick={ async () => {
                    const selectedItems = JSON.parse(val.data_json || '[]');
                    const XLSX = await import('xlsx');
                    const header = selectedItems.map((item: any) => item.text);
                    const ws = XLSX.utils.aoa_to_sheet([header]);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Template");
                    XLSX.writeFile(wb, `${val.name || 'template'}.xlsx`);
                  }}
                >{val.name}</Button>
              ))
            }
          </Flex>

          <div className="note">
            LƯU Ý:
            <br />
            - Giới hạn mỗi file upload tối đa 1000 dòng. Người  dùng có thể import nhiều file trên cùng một lần import.
            <br />
            - File import cần đủ các trường bắt buộc và đúng định dạng dữ liệu theo file mẫu đính kèm
            <br />
            - Danh sách template import được lưu theo cấu hình người dùng tạo
          </div>
        </Flex>
      </div>

      <CreateImportDataTemplateModal
        show={showImportDataTemplateModal}
        modalClose={() => {setShowImportDataTemplateModal(false)}}
        listSource={listSource}
        listSourceV2={listSourceV2}
        modalFinish={() => {setShowImportDataTemplateModal(false); getListData()}}
      />
    </>
  )
}

export default ImportDataStep1
